@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.ridepayment
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.web.models.RidePaymentNote

@Suppress("NON_EXPORTABLE_TYPE")
data class RidePaymentDto(
    val id: KmmLong?,
    val amount: Double,
    val driverId: KmmLong?,
    val passengerId: KmmLong?,
    val rideId: KmmLong?,
    val timestamp: DateTimeDto,
    val paymentKey: String,
    @Suppress("NON_EXPORTABLE_TYPE") val note: DtoName<RidePaymentNote>,
    val balanceAfter: Double?,
    val currencyId: Int?,
)
